module.exports = __webpack_public_path__ + "media/application/images/svgs/power-6d0ea16ee25303331ebb771198abb762.svg";